import React from 'react'
import styles from './main.scss'
import { loadAnalytics } from '../../../globals/load-analytics'
import {
  getCampaignCookieShow,
  setCampaignCookieAccepted,
  setCampaignCookieShow,
} from '../../../globals/storage'

class Cookie extends React.Component {

  defaultText = 'By using this site you agree to our'
  defaultLinkTitle = 'cookie policy'

  constructor(props) {
    super(props)

    this.state = {
      accepted: false,
      sticky: false,
    }
  }

  handleCookie() {
    const { campaignId, companyId } = this.props

    setCampaignCookieAccepted(campaignId)
    loadAnalytics(companyId)

    this.checkAccepted()
  }

  checkAccepted() {
    const { campaignId } = this.props

    const hasAccepted = getCampaignCookieShow(campaignId)
    if (hasAccepted) {
      this.setState({ accepted: true })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.page !== prevProps.page) {
      if (!this.state.accepted) {
        this.checkAccepted()
      }
    }
  }

  componentDidMount() {
    this.setState({ mounted: true })
    window.addEventListener('scroll', this.handleScroll)

    this.handleCookie()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  };

  handleScroll = () => {
    const doc = document.documentElement
    const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

    // handle Cookie positioning
    if (top > 36) {
      this.setState({ sticky: true })
    } else {
      this.setState({ sticky: false })
    }
  }

  handleAccept = () => {
    const { campaignId } = this.props
    setCampaignCookieShow(campaignId)

    this.setState({ accepted: true })
  }

  render() {
    if (this.state.accepted) {
      return null
    }

    const wrapperClass = `${styles.cookieWrapper} ${this.state.sticky ?
      styles.sticky :
      ''}`

    return (
      <div className={wrapperClass}>
        <div className={styles.left}>
          <span role="img" aria-label="cookie">
            🍪
          </span>
        </div>
        <div className={styles.center}>
          <p>
            {this.props.text || this.defaultText}
            {' '}
            <a href={this.props.linkUrl}
               target="_blank"
               rel="noopener noreferrer"
            >
              {this.props.linkTitle || this.defaultLinkTitle}
            </a>
            .
          </p>
        </div>
        <div className={styles.right} onClick={this.handleAccept}>
          &times;
        </div>
      </div>
    )
  }
}

export default Cookie
